import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { isFunction } from 'lodash';
import classnames from 'classnames';

import { CoreSelectBox } from 'components/core/library/selectBox';
import { Label } from 'components/core/Label';
import { Text } from 'components/core/Text';
import { ChevronDown } from 'components/svg';

import './selectBox.scss';

export default class SelectBox extends PureComponent {
	static propTypes = {
		/** ClassName */
		className: PropTypes.string,
		/** An array of options in the format of { value: <value>, display: <string> } */
		options: PropTypes.arrayOf(
			PropTypes.shape({
				value: PropTypes.any,
				display: PropTypes.any
			})
		),
		/** The default selected option. This value should match a value in the options list */
		value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
		/** Renders a larger select box */
		large: PropTypes.bool,
		/** Indicates whether the select box is disabled */
		disabled: PropTypes.bool,
		/** The label for the select box */
		label: PropTypes.node.isRequired,
		/** The id of the select box (used to set the label) */
		id: PropTypes.string.isRequired,
		/** The error message to be displayed on failed select box validation */
		errorMessage: PropTypes.node,
		/** A function that will receive the current select box and should return `true` if the select box is valid
		 * and `false` otherwise. */
		validator: PropTypes.func,
		/** Function called on each change to the select box */
		onChange: PropTypes.func,
		//  If this select box is part of a redux form, this will test validation
		reduxFormError: PropTypes.bool
	};

	static defaultProps = {
		options: []
	};

	constructor(props) {
		super(props);
		let hasError = false;
		if (isFunction(this.props.validator) && this.props.value.length) {
			hasError = this.props.validator(this.props.value);
		}
		this.state = { hasError, value: this.props.value };
	}

	componentWillReceiveProps(nextProps) {
		if (this.state.value !== nextProps.value) {
			this.setState({ value: nextProps.value });
		}
	}

	_onChange = (evt) => {
		const { value } = evt.target;
		const newState = { value, hasError: false };
		if (isFunction(this.props.validator) && value.length) {
			newState.hasError = this.props.validator(value);
		}

		this.setState(newState);
		if (isFunction(this.props.onChange)) {
			this.props.onChange(evt);
		}
	};

	_getSelectedValue() {
		const selected = this.props.options.find(
			(o) => o.value === this.state.value
		);
		if (selected) {
			return selected.display;
		}
		return null;
	}

	render() {
		const { id, disabled, label, large, className } = this.props;
		return (
			<Label
				htmlFor={this.props.id}
				text={this.props.label}
				textClassName="selectbox"
				className="select-box-label"
			>
				<Text size="small" className="selected-value">
					{this._getSelectedValue()}
				</Text>
				<CoreSelectBox
					className={classnames(className, {
						'select-input-large': large,
						'select-input-standard': !large,
						disabled,
						error: this.state.hasError || this.props.reduxFormError
					})}
					disabled={disabled}
					id={id}
					label={label}
					onChange={this._onChange}
					value={this.state.value}
					key="core-selectbox"
					options={this.props.options}
				/>
				<div className="dropdown-icon">
					<ChevronDown />
				</div>
				<div className="input-error" key="input-error">
					{this.state.hasError || this.props.reduxFormError ?
						this.props.errorMessage :
						null}
				</div>
			</Label>
		);
	}
}
